export enum ANALYTICS_PAGE_ZONE {
  CARE_TILE = 'Care Tile',
}

export enum ANALYTICS_CTA_VALUE {
  EXPERT_SERVICES_DESIGN_SERVICES_BRIEF = 'expertServices-Design Services:Printed Product Brief-hireAFreelancer',
}

export const URL_TARGET = '/design/get-started'
